var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.page.ranges,"label":"Plage d'observation","outlined":"","hide-details":""},model:{value:(_vm.timeRange),callback:function ($$v) {_vm.timeRange=$$v},expression:"timeRange"}})}
var staticRenderFns = []

export { render, staticRenderFns }